import React from "react";
import { AuthView } from "../auth/AuthViewRouter";
import Button from "../ui/Button";

interface PasswordResetSuccessViewProps {
  onSwitchView: (view: AuthView) => void;
}

const PasswordResetSuccessView: React.FC<PasswordResetSuccessViewProps> = ({
  onSwitchView,
}) => {
  return (
    <div className="auth-view">
      <div className="tw-text-center tw-mb-6">
        <div className="tw-inline-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-bg-green-100 tw-rounded-full tw-mb-4">
          <span className="tw-text-2xl tw-text-green-600">✓</span>
        </div>
        <h3 className="tw-text-xl tw-font-semibold tw-text-gray-800 tw-mb-6 tw-text-center">
          Пароль обновлён
        </h3>
      </div>

      <div className="tw-text-center tw-mb-8">
        <p className="tw-mb-4 tw-text-gray-700">
          Теперь вы можете войти в аккаунт с новым паролем
        </p>
      </div>

      <div className="tw-mb-6">
        <Button
          type="button"
          variant="primary"
          onClick={() => onSwitchView("login")}
          className="tw-w-full"
        >
          Войти сейчас
        </Button>
      </div>

      <div className="auth-links">
        <Button
          type="button"
          variant="link"
          onClick={() => onSwitchView("identifier")}
        >
          На главную
        </Button>
      </div>
    </div>
  );
};

export default PasswordResetSuccessView;
